import { matchPath } from 'react-router-dom'

import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { createBrowserHistory } from 'history'

import config from 'config'

const history = createBrowserHistory()

const basePath = '/activity'

const routes = [
  {
    path: basePath
  },
  {
    path: `${basePath}/insights/:insightId`
  },
  {
    path: `${basePath}/engagement`
  },
  {
    path: `${basePath}/accounts/:id`
  },
  {
    path: `${basePath}/contacts/:id`
  },
  {
    path: `${basePath}/deals`
  },
  {
    path: `${basePath}/demo/missed`
  }
]

export const initializeSentry = () => {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    environment: config.ENV,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history, routes, matchPath)
      })
    ],
    tracesSampleRate: 0.2
  })
}

export const captureException = Sentry.captureException

export const captureMessage = Sentry.captureMessage
